import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/auth';
import AppLayout from './components/AppLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ProjectList from './pages/ProjectList';
import ProjectHome from './pages/ProjectHome';
import ProjectDocuments from './pages/ProjectDocuments';
import DocumentView from './pages/DocumentView';
import ProjectTasks from './pages/ProjectTasks';
import ProjectCommunication from './pages/ProjectCommunication';
import ProjectPerso from './pages/ProjectPerso';
import ProjectSettings from './pages/ProjectSettings';
import ProjectIfc from './pages/ProjectIfc';
import ProjectCaptures from './pages/ProjectCaptures';
import ProjectSynthesis from './pages/ProjectSynthesis';
import PersonalSpace from './pages/PersonalSpace';
import Resources from './pages/Resources';
import SharedView from './pages/SharedView';
import SharedPrintView from './pages/SharedPrintView';
import SharedIfcViewer from './pages/SharedIfcViewer';
import AdminUsers from './pages/AdminUsers';
import AdminAi from './pages/AdminAi';
import AdminAiUsage from './pages/AdminAiUsage';
import ForceResetPassword from './pages/ForceResetPassword';

function RequireAuth({ children }: { children: JSX.Element }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ padding: 40 }}>Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  // Si l'admin a forcé un reset → on bloque tant que pas changé.
  if (user.must_reset_password) return <Navigate to="/changer-mot-de-passe" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/changer-mot-de-passe" element={<ForceResetPassword />} />
        <Route path="/share/:token" element={<SharedView />} />
        <Route path="/share-print/:token" element={<SharedPrintView />} />
        {/* Page PUBLIQUE (pas d'auth) : viewer IFC partagé via token.
            Utilisée par les liens générés par l'export HTML Interactif. */}
        <Route path="/viewer-partage" element={<SharedIfcViewer />} />
        <Route
          path="/*"
          element={
            <RequireAuth>
              <AppLayout>
                <Routes>
                  <Route index element={<Dashboard />} />
                  <Route path="projets" element={<ProjectList />} />
                  <Route path="projets/:id" element={<ProjectHome />}>
                    <Route index element={<Navigate to="documents" replace />} />
                    <Route path="documents" element={<ProjectDocuments />} />
                    <Route path="documents/:docId" element={<DocumentView />} />
                    <Route path="taches" element={<ProjectTasks />} />
                    <Route path="communication" element={<ProjectCommunication />} />
                    <Route path="perso" element={<ProjectPerso />} />
                    <Route path="ifc" element={<ProjectIfc />} />
                    <Route path="captures" element={<ProjectCaptures />} />
                    <Route path="synthese" element={<ProjectSynthesis />} />
                    <Route path="parametres" element={<ProjectSettings />} />
                  </Route>
                  <Route path="ressources" element={<Resources />} />
                  <Route path="perso" element={<PersonalSpace />} />
                  <Route path="admin/utilisateurs" element={<AdminUsers />} />
                  <Route path="admin/ia" element={<AdminAi />} />
                  <Route path="admin/ia/consommation" element={<AdminAiUsage />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </AppLayout>
            </RequireAuth>
          }
        />
      </Routes>
    </AuthProvider>
  );
}
